<template>
    <div :class="$attrs.class">
        <input :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-radio" :class="[{ error: error }, radioClass]"
               :type="type" :value="value" :checked="modelValue === value" @change="$emit('update:modelValue', value)"/>
        <label v-if="label" class="form-label mb-0" :for="id">{{ label }}</label>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import {v4 as uuid} from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `radio-input-${uuid()}`
            },
        },
        type: {
            type: String,
            default: 'radio',
        },
        radioClass: {
            type: String,
            default: '',
        },
        error: String,
        label: String,
        modelValue: {
            type: [String, Number, Boolean],
            default: false,
        },
        value: {
            type: [String, Number, Boolean],
            required: true,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
